import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import Analytics from 'APP_ROOT/services/analytics';
import BuildSettings from '../../buildSettings';
import Events from '../../common/events';
import HistoryUtil from '../../common/historyUtil';
import { strings } from '../../../localization';

export default class InvitationPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            invite: null,
            errorMessage: null
        };
    }

    componentDidMount() {
        Analytics.pageView();
        this.getInvitationDetails();
    }

    getInvitationDetails() {

        try {
            const invite = {
                token: window.location.getParams()['token'],
                signature: window.location.getParams()['signature'],
            };

            if (!invite.token || !invite.signature) {
                this.genericError(invite, "no invitation token/signature in url");
                return;
            }

            this.setState({invite});

            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.invitation_loading) } }));
            axios({
                method: 'post',
                url: BuildSettings.invitationQueryUrl(),
                data: JSON.stringify(invite),
            }).then(this.onGetInvitationDetailsResponse).catch((response) => {
                this.genericError(response);
            });
        } catch (e) {
            this.genericError(e, "invite error: problem parsing or saving invite token or signature");
        }
    }

    onGetInvitationDetailsResponse = (response) => {

        console.log(response);
        if (response && response.data) {
            if (response.data.status === "ERROR") {
                this.genericError(response, "invite error: get invitation details failed");
                return;
            }
            try {
                const inviteDetails = {
                    tag: response.data.payload.tagName,
                    role: response.data.payload.role,
                    ownerName: response.data.payload.ownerName,
                    ownerEmail: response.data.payload.ownerEmail,
                    accountId: response.data.payload.accountId,
                    inviteEmail: response.data.payload.inviteEmail
                }

                this.setState({ 
                    invite: {
                    ...this.state.invite,
                    ...inviteDetails
                    }
                }, () => {
                    this.props.setPendingInvite(this.state.invite);
                });

            } catch (e) {
                this.genericError(e);
            }
        } else {
            this.genericError(response, "invitation error: no response.data.payload");
        }
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    genericError(e, message) {

        console.error(e, message);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.setState({
            errorMessage: strings.formatString(strings.get_invite_detail_error)
        })
    }

    onLoginClick = (e) => {
        e.preventDefault();
        HistoryUtil.push(`/?token=${this.state.invite.token}`);
    }

    onCreateAccountClick = (e) => {
        e.preventDefault();
        HistoryUtil.push(`/create-account?token=${this.state.invite.token}`);
    }

    render() {

        // console.log(this.state);

        if (this.state.errorMessage) {
            return (
                <div className="container page-container page-error">
                    <h1>{strings.formatString(strings.app_oops)}</h1>
                    <hr />
                    <p>{this.state.errorMessage}</p>
                </div>
            )
        }

        if (!this.state.invite ||
            !this.state.invite.tag ||
            !this.state.invite.role ||
            !this.state.invite.accountId ||
            !this.state.invite.inviteEmail) {
                return null;
            }

        const roleLabel = strings[`tags_role_${this.state.invite.role.toLowerCase()}_label`];
        const ownerDisplay = this.state.invite.ownerName || this.state.invite.ownerEmail || null;

        return (
            <div className="container full-page invite-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <h3>{strings.formatString(strings.invitation_welcome, this.state.invite.inviteEmail)}</h3>
                            <h1>{ownerDisplay
                                ? strings.formatString(strings.invitation_title, <span className="blue">{ownerDisplay}</span>)
                                : strings.formatString(strings.invitation_title_generic)
                            }</h1>
                            <h3>
                                {strings.formatString(strings.invitation_access_level,
                                    <span className="blue">{roleLabel}</span>,
                                    <span className="blue">{`#${this.state.invite.tag}`}</span>
                                )}
                            </h3>
                            {this.state.errorMessage ?
                                <p><i className="material-icons yellow">warning</i>{this.state.errorMessage}</p>
                                : null}
                            <p>{strings.formatString(strings.invitation_m1)}</p>
                            <p>{strings.formatString(strings.invitation_m2)}</p>
                            <button className="btn btn-spacing btn-outline-blue" onClick={this.onCreateAccountClick}>{strings.formatString(strings.sign_in_sign_up)}</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

InvitationPage.propTypes = {
    setPendingInvite: PropTypes.func.isRequired
};
